// Angular
import { Component } from '@angular/core';
import { ajaxservice } from '../../../../services/ajaxservice'; // Common API service for both get and post
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router'; // To enable routing for this component
import { ToastrService } from 'ngx-toastr';// To use toastr
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
	employee_code: any;
	user_name: any;
	user_role: any;
	constructor(public ajax: ajaxservice, private router: Router, private toastr: ToastrService, private activatedRoute: ActivatedRoute) {

	}
	currentRouter = this.router.url;
	myFunction() {
		document.getElementById("myDropdown").classList.toggle("show");
	}
    ngOninit(){
		// this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
		this.user_name=localStorage.getItem('pro_user_name');
		this.user_role=localStorage.getItem('pro_user_role');
		console.log(localStorage.getItem('pro_user_name'));
		console.log(localStorage.getItem('pro_role_id'));
	}
	// logout() {
	// 	 this.router.navigate(['/login']);   
	// }  
	logout() {
		this.employee_code = localStorage.getItem('pro_employee_code');
		var empid = this.employee_code;
		var url = 'fp_logout/?';             // api url for getting the details with using post params
		var id = "employee_code";                      //id for using identify the amc name
		Swal.fire({
			title: 'Are you sure?',
			text: "Do you want to logout!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes',
			allowOutsideClick: false,                          //sweet alert will not close on oustside click
		}).then((result) => {
			Router
			if (result.value) {
				this.ajax.getdataparam(url, id, empid).subscribe((result) => { 
					if (result.response.response_code == "200") {

						localStorage.removeItem("pro_user_role");
						localStorage.removeItem("pro_employee_code");
						localStorage.removeItem("pro_employee_id");
						localStorage.removeItem("pro_org_type");
						localStorage.removeItem("pro_asideMenus");
						localStorage.removeItem("pro_user_status");
						localStorage.removeItem("pro_role_id");
						localStorage.removeItem("pro_organization_type");
						localStorage.removeItem("pro_ticket_id");
						localStorage.removeItem("pro_layoutConfig");
						localStorage.removeItem("pro_user_name");
						localStorage.removeItem("pro_language");					
					 
						//	localStorage.clear();
						// this.router.navigate(['login'])
						window.location.reload();
						// this.toastr.success(result.response.message, 'Success');        //toastr message for success
						//   this.router.navigateByUrl('/login');

					}
					else if (result.response.response_code == "400") {                //if failure
						this.toastr.error(result.response.message, 'Error');            //toastr message for error
					}
					else {                                                         //if not sucess
						this.toastr.error(result.response.message, 'Error');        //toastr message for error
					}
				}, (err) => {
					console.log(err);                                        //prints if it encounters an error
				});
			}
		})
	}



	// 		var url = 'fp_logout/';            
	// 		this.ajax.getdata(url).subscribe((result) => {
	// 		  if (result.response.response_code == "200") {                      

	// 		  }
	// 		  else if (result.response.response_code == "500"){                           
	// 			this.toastr.error(result.response.message, 'Error');       
	// 		  }
	//   else{                                                        
	// 	this.toastr.error(result.response.message, 'Error');        
	//   }
	// 		}, (err) => {                                          
	// 		  console.log(err);                                       
	// 		});

	// 	  }
}
